import React from 'react'
import { My } from '../components/My'
import { FAQ } from '../components/FAQ'
import { isMobile } from 'react-device-detect'
import useUserStore from '../store/useUserStore'
import { Helmet } from 'react-helmet-async'

export const QnA = () => {
  const userInfo = useUserStore((state: any) => state.userInfo)

  return (
    <>
      <Helmet>
        <title> 많이 묻는 질문 + 빠른 해결법 FAQ</title>
        <meta
          name="description"
          content="영상 생성, 플랜, 캐시, 자동 업로드, 수익 등 자주 묻는 질문에 대한 빠른 답변을 확인하세요."
        />
        <link rel="canonical" href="https://fastcut.fastseller.shop/QnA" />
      </Helmet>
      <div className="md:max-w-[816px] max-w-[375px]  my-0 mx-auto flex flex-col items-center gap-6 ">
        <div className="md:w-full w-[343px] ">
          <div className="flex justify-center mb-[24px]">
            <p className="font-bold text-[24px] md:text-[40px]">
              많이 묻는 질문 + 빠른 해결법
            </p>
          </div>
        </div>
        <FAQ />
      </div>
    </>
  )
}
